/* BAUM store：MEN／WOMEN タブ（ライブラリなし・約1KB）
 * <baum-gender-tabs data-sync="true"> の中の [role=tab] と [role=tabpanel] を data-gender で対応させて切り替える。
 * data-sync="true" のセクション同士は連動し、選んだタブをブラウザに記憶する。
 */
(() => {
  if (customElements.get('baum-gender-tabs')) return;

  const KEY = 'baum:gender';
  const EVENT = 'baum:gender';
  const load = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
  const save = (v) => { try { localStorage.setItem(KEY, v); } catch (e) { /* 保存できなくても動作は続ける */ } };

  class BaumGenderTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.sync = this.dataset.sync === 'true';

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(tab.dataset.gender, true));
        tab.addEventListener('keydown', (e) => this.onKey(e, i));
      });

      this.onSync = (e) => {
        if (this.sync && e.detail !== this.current) this.select(e.detail, false);
      };
      document.addEventListener(EVENT, this.onSync);

      if (this.sync && !window.Shopify?.designMode) {
        const saved = load();
        if (saved && saved !== this.current) this.select(saved, false);
      }
    }

    disconnectedCallback() {
      document.removeEventListener(EVENT, this.onSync);
    }

    get current() {
      const tab = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
      return tab ? tab.dataset.gender : null;
    }

    select(gender, byUser) {
      if (!this.tabs.some((t) => t.dataset.gender === gender)) return;
      this.tabs.forEach((t) => {
        const on = t.dataset.gender === gender;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((p) => { p.hidden = p.dataset.gender !== gender; });
      // data-bg-men / data-bg-women があれば、セクションの背景色も切り替える
      const bg = this.dataset['bg' + gender.charAt(0).toUpperCase() + gender.slice(1)];
      const section = this.closest('.baum-sec');
      if (bg && section) section.style.setProperty('--baum-bg', bg);
      if (byUser && this.sync) {
        save(gender);
        document.dispatchEvent(new CustomEvent(EVENT, { detail: gender }));
      }
    }

    onKey(e, i) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      const n = this.tabs.length;
      const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : n - 1)) % n];
      next.focus();
      this.select(next.dataset.gender, true);
    }
  }

  customElements.define('baum-gender-tabs', BaumGenderTabs);
})();
